import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  useRefresh,
  Datagrid,
  Title,
} from 'react-admin';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
//import ActionsField from './ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR } from '../../utils/dadosTelas';
import Dialogo from './DialogoCreateEdit';
import DialogoDeleteResource from './DialogoDeletar';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const DataGridLocal = ({
  handleEdit = () => {},
  handleDeletar = () => {},
  ...props
}) => {
  const classes = useStylesDatagrid();
  return (
    <>
      <Datagrid {...props} bulkActionButtons={false}>
        <Textofield
          source="nome"
          label="Título"
          sortable={false}
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
        />
        <ActionsField
          source="lalala"
          /* handleEdit={handleEdit}
          handleDeletar={handleDeletar} */
          textAlign="right"
          label="Ações"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
          const
          actions={[
            {
              title: 'Editar',
              icon: <EditOutlinedIcon />,
              onClick: (record) => handleEdit(record),
            },
            {
              title: 'Deletar',
              icon: <DeleteOutlineIcon />,
              onClick: (record) => handleDeletar(record),
            },
          ]}
        />
      </Datagrid>
    </>
  );
};
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogo = useRef(null);
  const refDialogoDeletar = useRef(null);

  const create = (tipo) => {
    if (refDialogo.current) {
      refDialogo.current.handleCreate(tipo);
    }
  };

  const edit = (data) => {
    if (refDialogo.current) {
      refDialogo.current.handleEdit(data.id);
    }
  };

  const deletar = (data) => {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(data.id);
    }
  };

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Vídeos Tutoriais FC" />
      <ListToolbar
        filters={<Filter />}
        actions={<ActionsList handleCriar={create} />}
        {...props}
      />
      <Paper
        elevation={1}
        style={{
          borderRadius: '20px',
          marginTop: '30px',
          display: 'flex',
          padding: '10px',
        }}
      >
        <DataGridLocal handleEdit={edit} handleDeletar={deletar} {...props} />
      </Paper>
      <Dialogo ref={refDialogo} handleClose={handleClose} />
      <DialogoDeleteResource
        ref={refDialogoDeletar}
        handleClose={handleClose}
      />
    </>
  );
};

const ContainerMyList = ({ ...props }) => (
  <ListBase {...props}>
    <MyList {...props} />
  </ListBase>
);

const PostPanel = ({ record }) => (
  <div>
    <br />
    <p>
      <span style={{ fontWeight: 'bold' }}>Link: </span>
      {record.link}
    </p>
    <br />
    <p>
      <span style={{ fontWeight: 'bold' }}>Descrição: </span>
      {record.descricao}
    </p>
    <br />
  </div>
);

const CategoryList = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR}>
    <ContainerMyList
      {...props}
      title="Vídeos Tutoriais FC"
      expand={<PostPanel />}
      component="div"
      bulkActionButtons={false}
      sort={{ field: 'nome', order: 'asc' }}
      perPage={20}
      pagination={false}
    />
  </ProtegerPagina>
);

export default CategoryList;
